class StatusbarController {
    constructor(evaluationService, userService, $stateParams, $state, $rootScope, $scope, $filter, $mdDialog) {
        let self = this;
        self.evaluationData = {};
        self.newEvaluation = true;
        self.mode = $state.includes('mini') ? 'MINI' : 'FULL';

        self.evaluationId = $stateParams.id;

        $scope.$on('$destroy', function() {
            self.stateChangeSuccessFn();
            self.onFreshEvaluation();
        });

        self.onFreshEvaluation = $rootScope.$on('FRESH_EVALUATION_DATA', (event, evaluation) => {
            if(evaluation && self.evaluationData && (self.evaluationData.nameOfProduct != evaluation.nameOfProduct
                || self.evaluationData.status != evaluation.status
                || self.evaluationData.companyName != evaluation.companyName)) {
                self.evaluationData = evaluation;
                $rootScope.evaluationStatusRootScope = $filter('beautifyStatus')(evaluation.status);
            }
        });

        self.stateChangeSuccessFn = $rootScope.$on('$stateChangeSuccess', (event, toState, toParams) => {
            if(self.newEvaluation) {
                self.loadEvaluation(toParams.id);
            } else if(evaluationService.currentEvaluation && self.evaluationData
                && (self.evaluationData.nameOfProduct != evaluationService.currentEvaluation.nameOfProduct
                || self.evaluationData.status != evaluationService.currentEvaluation.status
                || self.evaluationData.companyName != evaluationService.currentEvaluation.companyName)) {
                self.evaluationData = evaluationService.currentEvaluation;
                $rootScope.evaluationStatusRootScope = $filter('beautifyStatus')(self.evaluationData.status);
            }
        });

        self.upgradeToFull = ev => {
            $mdDialog.show(
            $mdDialog.confirm()
                .title('Upgrade mini evaluation into a full evaluation')
                .textContent('A new copy of this mini evaluation is created as a full evaluation')
                .ariaLabel('upgrade')
                .targetEvent(ev)
                .ok('UPGRADE')
                .cancel('CANCEL')
            ).then(
              () => evaluationService.upgradeToFull($stateParams.id)
                .then(
                  data => {
                      if (data !== undefined) {
                          $state.go('evaluation.basicInfo', {id: data.id});
                      }
                  }
                ),
              () => {}
            );
        };

        self.downgradeToMini = ev => {
            $mdDialog.show(
                $mdDialog.confirm()
                    .title('Create mini evaluation from this full evaluation')
                    .textContent('A new copy of this full evaluation is created as a mini evaluation')
                    .ariaLabel('downgrade')
                    .targetEvent(ev)
                    .ok('Create mini')
                    .cancel('CANCEL')
            ).then(
                () => evaluationService.downgradeToMini($stateParams.id)
                    .then(
                        data => {
                            if (data !== undefined) {
                                $state.go('mini.basicInfo', {id: data.id});
                            }
                        }
                    ),
                () => {}
            );
        };

        self.loadEvaluation = (id) => {
            if (id) {
                self.newEvaluation = false;
                if(!evaluationService.currentEvaluation) {
                    evaluationService.getEvaluationData(id, $state.includes('mini'))
                        .then((data) => {
                            self.evaluationData = data;
                            $rootScope.evaluationStatusRootScope = $filter('beautifyStatus')(self.evaluationData.status);
                        });
                } else {
                    self.evaluationData = evaluationService.currentEvaluation;
                    $rootScope.evaluationStatusRootScope = $filter('beautifyStatus')(self.evaluationData.status);
                }
            } else {
                self.newEvaluation = true;
                self.evaluationData = {nameOfProduct: 'Product Name', companyName: 'Company Name'};
                $rootScope.evaluationStatusRootScope = null;
            }
        };

        self.showAuthor = () => {
            //If you see different people evalution, you should be manager or admin,
            //so there should not be require to check role
            return self.evaluationData && self.evaluationData.user && self.evaluationData.user.id !== userService.currentUser.id;
        };

        self.loadEvaluation(self.evaluationId);
    }

    humanizeTimestamp(timestamp) {
        let date = new Date(timestamp * 1000); //Converting from UNIX timestamp to miliseconds
        return `created ${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`; //month + 1 because JS count months from 0 to 11 http://imgur.com/gallery/IppKJ
    }
}

StatusbarController.$inject = ['EvaluationService', 'UserService', '$stateParams', '$state', '$rootScope', '$scope', '$filter', '$mdDialog'];

export default StatusbarController;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/statusbar/statusbarController.js